export const postMetaInfo = (title, description, pathname) => ({
  title: `${title} | 블로그 | 엔터테인먼트 미디어 취업 엔터잡에듀`,
  description: description.replace(/<[^>]*>|&nbsp;|&gt;|amp;?/g, ''),
  canonical: pathname,
});
